import { render } from "./ReadingMaterial.vue?vue&type=template&id=314ce8b2"
import script from "./ReadingMaterial.vue?vue&type=script&lang=js"
export * from "./ReadingMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__